<template>
  <div class="fullpage">
    <div class="fp-item fubg1">
      <div class="fp-item-cont">
        <div class="slogan">
          <h3>大象科技</h3>
          <span>致力于研发全球领先的仿真系统和服务</span>
        </div>
      </div>
    </div>
    <div class="fp-item fubg2">
      <div class="fp-item-cont">
        <div class="fenleititle" style="visibility: hidden">公司简介</div>
      <div class="gy_content">
        <div class="aboutus" style="visibility: hidden">
          <p class="article">北京大象科技有限公司成立于2013年，拥有国家高新技术企业、北京市首批"专精特新"中小企业、仿真培训领域唯一家交通运输部职业建设联系点、教育部双师型教师培训基地、北京低空产业联盟成员、AOPA 民用无人机驾驶员训练机构等资质。</p>
          <p class="article">公司多年来致力于研发全球领先的数字化仿真系统和服务，业务范围由轨道交通逐步拓展至低空技术、应急安全等领域。通过数字化沉浸式解决方案赋能轨道、应急、低空用户的技术验证、场景推演与人才培养，提升行业安全及效率。服务行业企业用户300+家，业务覆盖国内20余个省份、香港特别行政区以及海外3个国家。</p>
          <p class="article">公司拥有一支团结、奋进、精研的高水平技术团队作为整个公司技术创新的强力引擎，承担复杂技术难题攻关任务，持续输出高品质技术成果。目前共拥有 4 项省部级科学进步奖，40项权威认证检测报告，44 项专利，270 项软著。</p>
          
        </div>
      </div>
      </div>
    </div>
    <div class="fp-item fubg3">
      <div class="fp-item-cont">
        <div class="fenleititle" style="visibility: hidden">公司资质</div>
        <el-carousel class="carousel1" indicator-position="outside" height="380px" :autoplay=false>
          <el-carousel-item>
            <div class="certificate" style="visibility: hidden">
              <div class="detailpic">
                <img src="@/assets/home/grade/cx.png"/>
                <span>诚信经营示范等级证书</span>
              </div>
              <div class="detailpic">
                <img src="@/assets/home/grade/lx.png"/>
                <span>立信单位等级证书</span>
              </div>
              <div class="detailpic">
                <img src="@/assets/home/grade/qy.png"/>
                <span>企业信用等级评价证书</span>
              </div>
              <div class="detailpic">
                <img src="@/assets/home/grade/ch.png"/>
                <span>重合同守信用等级证书</span>
              </div>
            </div>
          </el-carousel-item>
          <el-carousel-item>
            <div class="certificate" style="visibility: hidden">
              <div class="detailpic">
                <img src="@/assets/home/grade/ISO27001.png"/>
                <span>ISO27001证书</span>
              </div>
              <div class="detailpic">
                <img src="@/assets/home/grade/ISOIEC20000.png"/>
                <span>ISOIEC 20000证书</span>
              </div>
              <div class="detailpic">
                <img src="@/assets/home/grade/shouhou.png"/>
                <span>五星级售后服务认证证书</span>
              </div>
              <div class="detailpic">
                <img src="@/assets/home/grade/xinyong.png"/>
                <span>供应商信用认证</span>
              </div>
            </div>
          </el-carousel-item>
          <el-carousel-item>
            <div class="certificate" style="visibility: hidden">
              <div class="detailpic">
                <img src="@/assets/home/grade/huanjing.png"/>
                <span>环境管理体系认证证书</span>
              </div>
              <div class="detailpic">
                <img src="@/assets/home/grade/jiankang.png"/>
                <span>职业健康安全管理体系认证证书</span>
              </div>
              <div class="detailpic">
                <img src="@/assets/home/grade/zhiliang.png"/>
                <span>质量管理体系认证证书</span>
              </div>
              <div class="detailpic">
                <img src="@/assets/home/grade/lianhehui.png"/>
                <span>中国电子信息行业联合会证书</span>
              </div>
            </div>
          </el-carousel-item>
          <el-carousel-item>
            <div class="certificate" style="visibility: hidden">
              <div class="detailpic">
                <img src="@/assets/home/grade/yidengjiang.png"/>
                <span>城市轨道交通科学进步一等奖</span>
                <!-- 城市轨道交通科学进步一等奖（大象）（基于异构云的城轨列控通用集成测试平台关键技术研究与应用） -->
              </div>
              <div class="detailpic">
                <img src="@/assets/home/grade/chanquan.png"/>
                <span>知识产权管理体系认证证书</span>
              </div>
            </div>
          </el-carousel-item>
        </el-carousel>
        <div class="certificate_mobile">
          <div class="detailpic">
            <img src="@/assets/home/grade/cx.png"/>
            <span>诚信经营示范等级证书</span>
          </div>
          <div class="detailpic">
            <img src="@/assets/home/grade/lx.png"/>
            <span>立信单位等级证书</span>
          </div>
          <div class="detailpic">
            <img src="@/assets/home/grade/qy.png"/>
            <span>企业信用等级评价证书</span>
          </div>
          <div class="detailpic">
            <img src="@/assets/home/grade/ch.png"/>
            <span>重合同守信用等级证书</span>
          </div>
          <div class="detailpic">
            <img src="@/assets/home/grade/ISO27001.png"/>
            <span>ISO27001证书</span>
          </div>
          <div class="detailpic">
            <img src="@/assets/home/grade/ISOIEC20000.png"/>
            <span>ISOIEC 20000证书</span>
          </div>
          <div class="detailpic">
            <img src="@/assets/home/grade/shouhou.png"/>
            <span>五星级售后服务认证证书</span>
          </div>
          <div class="detailpic">
            <img src="@/assets/home/grade/xinyong.png"/>
            <span>供应商信用认证</span>
          </div>
          <div class="detailpic">
            <img src="@/assets/home/grade/huanjing.png"/>
            <span>环境管理体系认证证书</span>
          </div>
          <div class="detailpic">
            <img src="@/assets/home/grade/jiankang.png"/>
            <span>职业健康安全管理体系认证证书</span>
          </div>
          <div class="detailpic">
            <img src="@/assets/home/grade/zhiliang.png"/>
            <span>质量管理体系认证证书</span>
          </div>
          <div class="detailpic">
            <img src="@/assets/home/grade/lianhehui.png"/>
            <span>中国电子信息行业联合会证书</span>
          </div>
          <div class="detailpic">
            <img src="@/assets/home/grade/yidengjiang.png"/>
            <span>城市轨道交通科学进步一等奖</span>
          </div>
          <div class="detailpic">
            <img src="@/assets/home/grade/chanquan.png"/>
            <span>知识产权管理体系认证证书</span>
          </div>
        </div>
        <!-- 证书 -->
        <el-carousel  class="carousel2" indicator-position="outside" height="300px" :autoplay=false>
          <el-carousel-item>
            <div class="certificate2" style="visibility: hidden">
              <div class="detailpic">
                <img src="@/assets/home/zs/software1.png"/>
                <span>软件企业证书</span>
              </div>
              <div class="detailpic">
                <img src="@/assets/home/zs/software2.png"/>
                <span>软件企业证书</span>
              </div>
              <div class="detailpic">
                <img src="@/assets/home/zs/CMMI5.png"/>
                <span>CMMI5</span>
              </div>
            </div>
          </el-carousel-item>
          <el-carousel-item>
            <div class="certificate2" style="visibility: hidden">
              <div class="detailpic">
                <img src="@/assets/home/zs/CS2.png"/>
                <span>CS2证书</span>
              </div>
              <div class="detailpic">
                <img src="@/assets/home/zs/zhuanjing.png"/>
                <span>北京市“专精特新”中小企业证书</span>
              </div>
              <div class="detailpic">
                <img src="@/assets/home/zs/gaoxin.png"/>
                <span>高新技术企业证书</span>
              </div>
            </div>
          </el-carousel-item>
          <el-carousel-item>
            <div class="certificate2" style="visibility: hidden">
              <div class="detailpic">
                <img src="@/assets/home/zs/xinjishu.png"/>
                <span>新技术新产品证书-城市轨道交通全自动运行系统全场景仿真平台</span>
              </div>
              <div class="detailpic">
                <img src="@/assets/home/zs/kexue.png"/>
                <span>北京市轨道交通学会科学技术进步奖二等奖</span>
                <!-- 北京市轨道交通学会科学技术进步奖二等奖-融合客流推演的城轨行车调度场景化智能模拟演练技术研究及应用 -->
              </div>
              <div class="detailpic">
                <img src="@/assets/home/zs/wurenji.png"/>
                <span>民用无人机驾驶员训练机构合格证</span>
              </div>
            </div>
          </el-carousel-item>
        </el-carousel>
        <div class="certificate_mobile" style="margin-top: 50px;">
          <div class="detailpic">
              <img src="@/assets/home/zs/software1.png"/>
              <span>软件企业证书</span>
            </div>
            <div class="detailpic">
              <img src="@/assets/home/zs/software2.png"/>
              <span>软件企业证书</span>
            </div>
            <div class="detailpic">
              <img src="@/assets/home/zs/CMMI5.png"/>
              <span>CMMI5</span>
            </div>
            <div class="detailpic">
              <img src="@/assets/home/zs/CS2.png"/>
              <span>CS2证书</span>
            </div>
            <div class="detailpic">
              <img src="@/assets/home/zs/zhuanjing.png"/>
              <span>北京市“专精特新”中小企业证书</span>
            </div>
            <div class="detailpic">
              <img src="@/assets/home/zs/gaoxin.png"/>
              <span>高新技术企业证书</span>
            </div>
            <div class="detailpic">
              <img src="@/assets/home/zs/xinjishu.png"/>
              <span>新技术新产品证书-城市轨道交通全自动运行系统全场景仿真平台</span>
            </div>
            <div class="detailpic">
              <img src="@/assets/home/zs/kexue.png"/>
              <span>北京市轨道交通学会科学技术进步奖二等奖</span>
            </div>
            <div class="detailpic">
              <img src="@/assets/home/zs/wurenji.png"/>
              <span>民用无人机驾驶员训练机构合格证</span>
            </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { onMounted } from 'vue';
import { useHead } from '@vueuse/head'
useHead({
      title: '北京大象科技有限公司官网',
      meta: [
        { name: 'description', content: '北京大象科技有限公司多年来致力于研发全球领先的数字化仿真系统和服务，业务范围由轨道交通逐步拓展至低空技术、应急安全等领域。通过数字化沉浸式解决方案赋能轨道、应急、低空用户的技术验证、场景推演与人才培养，提升行业安全及效率。'},
        { name: 'keywords', content:"轨道运营、地铁、铁路、低空、应急、培训、竞赛、实训基地、北京大象、大象科技、北京大象科技有限公司、北京大象科技有限公司官网"}
      ]
    })
    // const optionList = [
    //   {label:'',value:'@/assets/home/诚信经营示范等级证书.png'}
    //   {label:'',value:'@/assets/home/诚信经营示范等级证书.png'}
    //   {label:'',value:'@/assets/home/诚信经营示范等级证书.png'}
    //   {label:'',value:'@/assets/home/诚信经营示范等级证书.png'}
    // ]
    onMounted(()=>{
      var element = document.getElementById('myElement');
      element.scrollTop = 0;
    })
</script>
<style lang="less" scoped>

@keyframes slideUp {
  from {
    opacity: 0;
    transform: translateY(100%);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
.slogan{
  margin-top: 30vh;
  // margin-left: 20%;
  opacity: 0; /* 初始透明度为0 */
  transform: translateY(100%); /* 初始位置在屏幕下方 */
  animation: slideUp 1.5s ease forwards; /* 应用动画并保持在结束状态 */
  h3{
    color:#fff;
    font-size: 88px;
    text-shadow: 0px 8px 8px rgba(0,0,0,0.5);
    margin:0;
  }
  span{
    color:#fff;
    font-size: 50px;
    text-shadow: 0px 8px 8px rgba(0,0,0,0.5);
    margin-top: 20px;
    display:block;
  }
    
}
.fullpage{
  width: 100%;
  height: 100%;
  .fp-item{
    width: 100%;
    .fp-item-cont{
      width:1200px;
      margin:0 auto;
      left:50%;
      margin-left:-600px;
      float:left;
      position: relative;
      margin-bottom: 50px;
    }
  }
  .fubg1{
    width:100%;
    height:100vh;
    background: url("@/assets/home_bg.jpg") no-repeat;
    background-size: cover;
    overflow-y: hidden;
  }
  .fubg2{
    width:100%;
    min-height:100vh;
    background: url("@/assets/content_bg.png") no-repeat;
    background-size: cover;
    overflow-y: hidden;
    .fenleititle{
      margin-top:170px;
      margin-bottom: 100px;
    }
    .article{
      margin:50px auto;
    }
    .detailpic{
      text-align:center;
    }
  }
  .fubg3{
    width:100%;
    min-height:100vh;
    background: #fff;
    .fenleititle{
      margin-top:50px;
    }
    .carousel2{
      margin-top:50px;
    }
    :deep(.el-carousel__arrow--left){
      left:2px;
      color:#CD4A26;
    }
    :deep(.el-carousel__arrow--right){
      right:2px;
      color:#CD4A26;
    }
    .certificate{
      display:flex;
      justify-content: center;
      .detailpic{
        width:22%;
        background:#F7F7F7;
        text-align:center;
        padding:15px 0;
        margin: 0 10px;
        img{
          width:85%;
        }
        span{
          display:block;
          margin-top:5px;
        }
      }
    }
    .certificate2{
      display:flex;
      justify-content: center;
      .detailpic{
        width:30%;
        background:#F7F7F7;
        text-align:center;
        padding:15px 0;
        margin: 0 10px;
        img{
          width:90%;
        }
        span{
          display:block;
          margin-top:5px;
        }
      }
    }
    :deep(.el-carousel__indicators--outside){
      button{
        background-color:#CD4A26 !important;
      }
      
    }
  }
  
}
.detailpic img{
    transition: transform 0.5s ease;
}
.detailpic img:hover{
    transform: scale(1.08);
}
// 平板样式
@media (max-width: 1200px) {
  .fullpage{
    .fenleititle:before {
      content: '';
      width: 50px;
      height: 3px;
      background: #CD4A26;
      position: absolute;
      margin-left: -120px;
      margin-top: 24px;
    }
    .fenleititle:after {
        content: '';
        width: 50px;
        height: 3px;
        background: #CD4A26;
        position: absolute;
        margin-top: 24px;
        margin-left: 70px;
    }
    .fubg2{
      height:auto !important;
      .fenleititle{
        margin-top:50px;
        margin-bottom:50px;
      }
      .article{
        margin: 20px auto;
      }
    }
    .fubg3{
      height:auto !important;
    }
    .fp-item-cont{
      width: 92% !important;
      margin: 0 4% !important;
      left: 0 !important;
      float: left !important;
      position: relative !important;
      .detailpic{
        width:100%;
        img{
          width:100%;
        }
      }
    }
  }
}
</style>